import { useState } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import Swal from "sweetalert2";
import { createLegalProcessDocumentService } from "../services/createLegalProcessDocument.service";
import { deleteLegalProcessDocumentService } from "../services/deleteLegalProcessDocument.service";
import { updateLegalProcessDocumentService } from "../services/updateLegalProcessDocument.service";

const initialState = {
  accident: "",
  files: [],
};

export const useLegalProcessDocumentCommand = (refresh) => {
  const fetchData = useFetch();
  const [errors, setErrors] = useState({ hasErrors: false, errors: {} });
  const [loading, setLoading] = useState(false);
  const [legalProcessDocument, setLegalProcessDocument] =
    useState(initialState);

  const handleChange = ({ name, value }) => {
    setLegalProcessDocument((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const createLegalProcessDocument = async () => {
    try {
      setLoading(true);
      const isValid = validations(legalProcessDocument);
      if (!isValid) return;

      const formData = new FormData();
      formData.append("accident", legalProcessDocument.accident);
      legalProcessDocument.files.forEach((file) => {
        formData.append("files", file);
      });

      const response = await createLegalProcessDocumentService(fetchData)(
        formData
      );

      refresh?.();
      Swal.fire({
        icon: "success",
        title: "Documentos de procesos legales registrado",
        text: response.message,
      });
      setLegalProcessDocument(initialState);
      setErrors({ hasErrors: false, errors: {} });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al registrar el documento de proceso legal",
      });
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const deleteLegalProcessDocument = async (id) => {
    try {
      const result = await Swal.fire({
        icon: "warning",
        title: "¿Estás seguro?",
        text: "Esta acción eliminará el documento de proceso jurídico.",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });

      if (!result.isConfirmed) return;

      setLoading(true);
      const response = await deleteLegalProcessDocumentService(fetchData)(id);

      refresh?.();
      Swal.fire({
        icon: "success",
        title: "Documento eliminado",
        text: response.message,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al eliminar el documento de proceso jurídico",
      });
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const updateLegalProcessDocument = async (id, file) => {
    try {
      setLoading(true);

      if (!file) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Debe seleccionar un archivo para reemplazar el documento.",
        });
        return;
      }

      const response = await updateLegalProcessDocumentService(fetchData)(id, file);

      refresh?.();
      Swal.fire({
        icon: "success",
        title: "Documento actualizado",
        text: response.message,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al actualizar el documento de proceso jurídico",
      });
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const validations = (legalProvisionDocument) => {
    const errors = { hasErrors: false, errors: {} };

    if (!legalProvisionDocument.accident) {
      errors.hasErrors = true;
      errors.errors.accident = "El campo 'Siniestro' es obligatorio.";
    }

    if (legalProvisionDocument.files.length === 0) {
      errors.hasErrors = true;
      errors.errors.files = "Debe adjuntar al menos un archivo.";
    }

    setErrors(errors);
    return !errors.hasErrors;
  };

  return {
    legalProcessDocument,
    handleChangeLegalProcessDocument: handleChange,
    errors,
    createLegalProcessDocument,
    deleteLegalProcessDocument,
    updateLegalProcessDocument,
    loading,
    initialState,
  };
};
